module.exports = __webpack_public_path__ + "img/prize-04.d2d86d8e.png";